import { Type, type Static } from "typebox";

export const PRODUCT_SESSION_POLICY = {
  idleMinutes: { minimum: 15, maximum: 60, default: 60 },
  maximumHours: { minimum: 1, maximum: 12, default: 12 },
} as const;

const InternalIdSchema = Type.String({ format: "uuid" });
const DisplayNameSchema = Type.String({ minLength: 1, maxLength: 240 });
const TimezoneSchema = Type.String({ minLength: 1, maxLength: 120 });
const LocaleSchema = Type.String({ minLength: 1, maxLength: 120 });
const LogoUrlSchema = Type.Union([Type.String({ minLength: 1, maxLength: 512 }), Type.Null()]);
const VisibilitySchema = Type.Union([
  Type.Literal("owners"),
  Type.Literal("owners_admins"),
]);

export const UpdateOrganizationSettingsV1Schema = Type.Object({
  displayName: DisplayNameSchema,
  timezone: TimezoneSchema,
  locale: LocaleSchema,
  productSessionIdleMinutes: Type.Integer({
    minimum: PRODUCT_SESSION_POLICY.idleMinutes.minimum,
    maximum: PRODUCT_SESSION_POLICY.idleMinutes.maximum,
  }),
  productSessionMaximumHours: Type.Integer({
    minimum: PRODUCT_SESSION_POLICY.maximumHours.minimum,
    maximum: PRODUCT_SESSION_POLICY.maximumHours.maximum,
  }),
  analyticsVisibility: VisibilitySchema,
  costVisibility: VisibilitySchema,
}, { additionalProperties: false });
export type UpdateOrganizationSettingsV1 = Static<typeof UpdateOrganizationSettingsV1Schema>;

export const OrganizationSettingsV1Schema = Type.Object({
  version: Type.Literal(1),
  organizationId: InternalIdSchema,
  displayName: DisplayNameSchema,
  logoUrl: LogoUrlSchema,
  timezone: TimezoneSchema,
  locale: LocaleSchema,
  productSessionIdleMinutes: Type.Integer({
    minimum: PRODUCT_SESSION_POLICY.idleMinutes.minimum,
    maximum: PRODUCT_SESSION_POLICY.idleMinutes.maximum,
  }),
  productSessionMaximumHours: Type.Integer({
    minimum: PRODUCT_SESSION_POLICY.maximumHours.minimum,
    maximum: PRODUCT_SESSION_POLICY.maximumHours.maximum,
  }),
  analyticsVisibility: VisibilitySchema,
  costVisibility: VisibilitySchema,
  canEdit: Type.Boolean(),
  retentionMonths: Type.Literal(13),
  versionTag: Type.String({ minLength: 1, maxLength: 64, pattern: "^[1-9][0-9]*$" }),
}, { additionalProperties: false });
export type OrganizationSettingsV1 = Static<typeof OrganizationSettingsV1Schema>;

export const OrganizationLogoMutationV1Schema = Type.Object({
  version: Type.Literal(1),
  organizationId: InternalIdSchema,
  logoUrl: LogoUrlSchema,
  versionTag: Type.String({ minLength: 1, maxLength: 64, pattern: "^[1-9][0-9]*$" }),
}, { additionalProperties: false });
export type OrganizationLogoMutationV1 = Static<typeof OrganizationLogoMutationV1Schema>;
